<template>
    <div v-if="!isDataLoading" class="pb-5">
        <b-alert variant="success" show>{{yapilanToplamMektup | formatNumber | replaceComma}} mektup yapılmış.</b-alert>
        <b-alert variant="success" show>{{yapilanToplamKart | formatNumber | replaceComma}} kart yapılmış.</b-alert>

        <LineChart :collection="dataBelge"></LineChart>
        <hr>
        <h3 class="text-center">Kart</h3>
        <LineChart :collection="dataKartHedef"></LineChart>
        <hr>
        <h3 class="text-center">Mektup</h3>
        <LineChart :collection="dataMektupHedef"></LineChart>
    </div>
    <div v-else>
        <div class="text-danger">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Rapor Oluşturuluyor...</strong>
        </div>
    </div>
</template>

<script>
    import LineChart from "@/components/LineChart";
    import {HaftalikHedefIstatistikRapor, ToplamHaftalikRapor} from "@/api/belgeler";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {mapGetters} from "vuex";
    import BarChart from "@/components/BarChart";

    export default {
        name: "HaftalikToplamRaporGrafik",
        data() {
            return {
                yapilanToplamKart: 0,
                yapilanToplamMektup: 0,
                isDataLoading: true,
                dataBelge : { labels: [],
                    datasets: [
                        {
                            label: 'Mektuplar', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#f87979', pointBorderColor: '#f87979',
                        },
                        {
                            label: 'Kartlar', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#11489e', pointBorderColor: '#11489e',
                        }
                    ]
                },
                dataKartHedef : { labels: [],
                    datasets: [
                        {
                            label: 'Hedefe Ulaşanlar', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#00CC66', pointBorderColor: '#00CC66',
                        },
                        {
                            label: 'Hedefe Ulaşamayan', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#FF8000', pointBorderColor: '#FF8000',
                        },
                        {
                            label: 'Hiç Yapmayan', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#FF0000', pointBorderColor: '#FF0000',
                        }
                    ]
                },
                dataMektupHedef: { labels: [],
                    datasets: [
                        {
                            label: 'Hedefe Ulaşanlar', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#00CC66', pointBorderColor: '#00CC66',
                        },
                        {
                            label: 'Hedefe Ulaşamayan', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#FF8000', pointBorderColor: '#FF8000',
                        },
                        {
                            label: 'Hiç Yapmayan', data: [],
                            fill: false, lineTension: 0, borderWidth: 4,
                            borderColor: '#FF0000', pointBorderColor: '#FF0000',
                        }
                    ]
                }
            }
        },
        computed: {
            ...mapGetters([
                'girisYapmismi'
            ])
        },
        mounted () {
        },
        async created() {
            if (!this.girisYapmismi)
                await new GoogleTokenIleGirisYapmayiDene(this);

            if (!this.girisYapmismi) {
                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/haftalik-toplam-rapor-gorsel"))
                }, 3000);
                return
            }
            
            const { data } = await ToplamHaftalikRapor()
            this.yapilanToplamKart = data.yaptigiToplamKart
            this.yapilanToplamMektup = data.yaptigiToplamMektup
            
            let yAxis = []
            let kart = []
            let mektup = []
            
            data.liste.reverse().map((item) => {
                let haftaNo = data.liste.length - item.haftaninSirasi;
                yAxis.push(haftaNo + ". Hafta")
                kart.push(item.bitenKartSayisi)
                mektup.push(item.bitenMektupSayisi)
            })
            
            this.dataBelge.labels = yAxis
            this.dataBelge.datasets[0].data = mektup
            this.dataBelge.datasets[1].data = kart
            
            let mektupHedefeUlasan = []
            let mektupHedefeUlasamayan =  []
            let mektupHicYapmayan = []
            let kartHedefeUlasan = []
            let kartHedefeUlasamayan = []
            let kartHicYapmayan = []
            
            const { data: hedef } = await HaftalikHedefIstatistikRapor()
            
            hedef.reverse().map((item) => {
                mektupHedefeUlasan.push(item.mektupHedefeUlasan)
                mektupHedefeUlasamayan.push(item.mektupHedefeUlasamayan)
                mektupHicYapmayan.push(item.mektupHicYapmayan)

                kartHedefeUlasan.push(item.kartHedefeUlasan)
                kartHedefeUlasamayan.push(item.kartHedefeUlasamayan)
                kartHicYapmayan.push(item.kartHicYapmayan)
            })

            this.dataKartHedef.labels = yAxis
            this.dataKartHedef.datasets[0].data = kartHedefeUlasan
            this.dataKartHedef.datasets[1].data = kartHedefeUlasamayan
            this.dataKartHedef.datasets[2].data = kartHicYapmayan
            
            this.dataMektupHedef.labels = yAxis
            this.dataMektupHedef.datasets[0].data = mektupHedefeUlasan
            this.dataMektupHedef.datasets[1].data = mektupHedefeUlasamayan
            this.dataMektupHedef.datasets[2].data = mektupHicYapmayan
            
            this.isDataLoading = false
        },
        components: {
            BarChart,
            LineChart
        }
    }
</script>

<style scoped>

</style>